import { useCallback } from 'react';
import useConfig from '@/hooks/use-config/index';
import submittalsService from '@/services/api/submittalsService.js';
import useSubmittalsDataElements from '@/hooks/use-submittals/useSubmittalsDataElements';

const useAllowedReceiverCheck = () => {
    const { config } = useConfig();
    const { dataElements } = useSubmittalsDataElements();

    const checkAllowedReceiver = useCallback(async (dataElementId = '') => {
        if (!config?.produces) return false;
        const [err, data] = await submittalsService.getAllowedReceiverByDataElement(dataElementId);
        if (err || !data) return false;
        return data.some(item => {
            if (!item.receiver_details) return false;
            if (!dataElements.some(de => de.dataElementId === item.data_element_id)) return false;
            const matchingProduce = config.produces.find(p => p.id === item.data_element_id);
            if (!matchingProduce) return false;
            return item.receiver_details.some(({ receiver_org_id }) =>
                matchingProduce.to?.some(to => to.id === receiver_org_id)
            );
        });
    }, [config?.produces, dataElements]);

    return { checkAllowedReceiver, configProducesReady: !!config?.produces };
};

export default useAllowedReceiverCheck;
